import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kmqjsus8ac: FaireBrandEntity = {
  token: "b_kmqjsus8ac",
  type: "brand",
  name: "First Row",
  avatarUrl:
    "https://cdn.faire.com/fastly/d15d9a8323b131173fa812c5fead166b3aac502e51534421ebb9f7478d2bff5a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4b4710acc1a0b631dd60855b7e80df75daa5d23235693adf0f24c7ba1e9615ba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d15d9a8323b131173fa812c5fead166b3aac502e51534421ebb9f7478d2bff5a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4b4710acc1a0b631dd60855b7e80df75daa5d23235693adf0f24c7ba1e9615ba.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 105,
  isInsider: true,
  description:
    "First Row is an LA-based street wear brand offering reimagined American classics for young men. Inspired by time-honored sportswear, our collection features new and re-invented retro-fit styles exclusively for the fashion-forward. Our one-of-a-kind pieces give a lasting experience that blends both the simplicity of the past and the brave thrill of the future.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:43.446Z",
    importedBy: "entity-db-cli",
  },
};
